import type { SVGProps } from "react";
export interface CoinsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoinsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoinsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.874 17.987c-1.292.682-3.188 1.138-5.874 1.139-2.686 0-4.583-.457-5.875-1.139V19c0-.03.033.405.883.905.832.49 2.363.97 4.992.97s4.16-.48 4.993-.97c.795-.468.874-.88.881-.905zm6-4.987v-1.016q-.198.108-.415.207a1.125 1.125 0 0 1-.918-2.055c.96-.428 1.23-.875 1.306-1.055l.027-.08V5a1.125 1.125 0 0 1 2.25 0v8c0 1.437-1.335 2.892-3.814 3.605a1.125 1.125 0 0 1-.621-2.163c2.07-.595 2.185-1.486 2.186-1.443Zm-3.75 6c0 1.034-.721 2.097-1.992 2.844-1.293.76-3.261 1.28-6.132 1.28s-4.84-.52-6.133-1.28C1.597 21.097.875 20.034.875 19v-8a1.125 1.125 0 0 1 2.25 0v4l.018.056c.048.132.224.473.865.85.832.489 2.364.97 4.992.97 2.63 0 4.16-.48 4.993-.97.64-.377.816-.718.864-.85l.018-.055V11a1.125 1.125 0 0 1 2.25 0v8Z"
      />
      <path
        fill={color}
        d="M14.857 10.944c-.048-.131-.223-.472-.864-.85-.832-.489-2.364-.969-4.993-.969-2.628 0-4.16.48-4.992.97-.854.502-.883.94-.883.905s.029.403.883.905c.832.49 2.364.97 4.992.97 2.63 0 4.16-.48 4.993-.97.791-.465.874-.875.881-.905zM20.875 5c-.008-.03-.091-.44-.882-.905-.832-.49-2.364-.97-4.992-.97-2.63 0-4.16.48-4.993.97-.854.502-.883.94-.883.905v.023a1.125 1.125 0 0 1-2.25 0V5c0-1.034.722-2.097 1.992-2.845C10.16 1.395 12.13.875 15 .875s4.84.52 6.132 1.28c1.271.748 1.992 1.81 1.992 2.845l-.016.278c-.165 1.389-1.561 2.745-4.037 3.393l-.113.023a1.126 1.126 0 0 1-.456-2.2l.396-.116c1.37-.433 1.794-.997 1.922-1.25zm-3.758 6.195c-.084.971-.794 1.95-1.985 2.65-1.293.76-3.261 1.28-6.132 1.28s-4.84-.52-6.133-1.28C1.597 13.097.875 12.035.875 11c0-1.034.722-2.097 1.992-2.845C4.16 7.395 6.13 6.875 9 6.875s4.84.52 6.132 1.28c1.271.748 1.993 1.81 1.993 2.845z"
      />
    </svg>
  );
}
